import type { ClaimWithRelations } from "../api/use-claim";
import type { AssessmentMetadata, EligibilityDebate } from "../api/use-claim-insights";

/**
 * The AI's eligibility verdict on a claim, or `undefined` without a study.
 * The assessment expert is authoritative; the debate's most probable verdict is the
 * fallback for payloads that predate `expert.isEligible`.
 */
export function getAiEligibilityVerdict(claim: ClaimWithRelations | undefined): boolean | undefined {
  const assessment = claim?.insights?.find((insight) => insight?.type?.type === "ASSESSMENT");
  const contradictions = claim?.insights?.find((insight) => insight?.type?.type === "CONTRADICTIONS");
  const assessmentMetadata = assessment?.metadata as AssessmentMetadata | null | undefined;
  const debateMetadata = contradictions?.metadata as EligibilityDebate | null | undefined;

  const expertVerdict = assessmentMetadata?.expert?.isEligible;
  if (expertVerdict !== undefined) {
    return expertVerdict;
  }
  const debateVerdict = debateMetadata?.mostProbableVerdict;
  if (debateVerdict === "ELIGIBLE") {
    return true;
  }
  if (debateVerdict === "NOT_ELIGIBLE") {
    return false;
  }
  return undefined;
}
